import { styled } from 'twin.macro';

const StyledListItem = styled.li(({ cursor }) => ({
    backgroundColor: '#E0F0EF',
    padding: '1rem',
    listStyle: 'none',
    color: '#506690',
    cursor: cursor || 'pointer',
    borderBottom: '1px solid lightgray',
    '&:hover': {
        backgroundColor: '#C3E4E2',
    },
}));

const FormPickerItem = ({ onClick, data, cursor }) => (
    <StyledListItem onClick={onClick} cursor={cursor}>
        {data?.img && <img src={data?.img} width={60} height={50} alt={data?.name} className="mr-2" />}
        {data?.icon && <span className="pr-2">{data.icon}</span>}
        {data.name}
    </StyledListItem>
);

export default FormPickerItem;
